export class ScrollService {
    savedScroll = 0;
    locks = new Set();
    isPortrait = false;
    savedScrollRelative = 0;
    preventBodyScrollingAttribute = 'prevent-scrolling';
    scrollEl = document.scrollingElement || document.documentElement;

    scrollTo = (YAxisPosition) => {
        this.savedScroll = 0;
        this.scrollEl.scrollTop = YAxisPosition;
    };

    enableBodyScroll = (lockId) => {
        if (!this.locks.has(lockId)) {
            return;
        }

        this.locks.delete(lockId);

        if (this.locks.size > 0) {
            return;
        }

        this.disengageLock();
    };

    disableBodyScroll = (lockId) => {
        const isAlreadyLocked = this.locks.size > 0;

        if (!this.locks.has(lockId)) {
            this.locks.add(lockId);
        }

        if (isAlreadyLocked) {
            return;
        }

        this.engageLock();
    };

    onOrientationChange = () => {
        this.isPortrait = !this.isPortrait;
        this.scrollEl.style.top = this.isPortrait ? `${-this.savedScroll}px` : `${-this.savedScroll * this.savedScrollRelative}px`;
    };

    engageLock = () => {
        this.savedScroll = this.scrollEl.scrollTop;
        this.savedScrollRelative = this.savedScroll / this.scrollEl.scrollHeight;
        this.isPortrait = window.innerHeight > window.innerWidth;
        this.scrollEl.style.top = `${-this.scrollEl.scrollTop}px`;
        this.scrollEl.setAttribute(this.preventBodyScrollingAttribute, 'true');

        window.addEventListener('orientationchange', this.onOrientationChange);
    };

    disengageLock = () => {
        this.scrollEl.removeAttribute(this.preventBodyScrollingAttribute);
        this.scrollEl.scrollTop = this.savedScroll;

        this.isPortrait = false;
        this.scrollEl.style.top = '';
        this.savedScrollRelative = 0;
        this.savedScroll = 0;

        window.removeEventListener('orientationchange', this.onOrientationChange);
    };
}

export const scrollService = new ScrollService();
